<template>
  <div v-if="isAdmin" class="playground panel-admin-body">
    <!--   <winners survey-code="eCsy84LtjCTMUzZQXowZ9ykC2MDpT4cb"/> -->
    <div class="title">
      <div class="d-flex">
        {{ title }}
      </div>
    </div>
    <div class="row pt-3">
      <h4>Preditive Chart</h4>
      <predictive-analytics-chart ref="predictiveAnalyticsChart"
          :e-chart-mini-id="'ranks-chart-mini'"
          :e-chart-id="'ranks-chart'"
          :input-report-type-name="'Chart - Moat Rank'"
          :modal-id="chartInsightModalId"
          :raw-data="{data: finalPredictiveAnalyticsData}" 
          :input-client-chart="{}"
          :is-saved-card="false"
          @save-table="saveNpsReportTable"
          @save-criteria="buildClientChart"/> 

      <h4>Ranks Chart</h4>
      <ranks-chart ref="ranksChart"
          :e-chart-mini-id="'ranks-chart-mini'"
          :e-chart-id="'ranks-chart'"
          :input-report-type-name="'Chart - Moat Rank'"
          :modal-id="chartInsightModalId"
          :raw-data="{data: finalRanksData}" 
          :input-client-chart="{}"
          :is-saved-card="false"
          @save-table="saveNpsReportTable"
          @save-criteria="buildClientChart"/> 
    </div>
    <div class="row pt-3">
      <h4>Trends Chart</h4>
      <trends-chart ref="trendsChart"
          :e-chart-mini-id="'trends-chart-mini'"
          :e-chart-id="'trends-chart'"
          :input-report-type-name="'Chart - Competitive Trends'"
          :modal-id="chartInsightModalId"
          :raw-data="{data: finalTrendsData}" 
          :input-client-chart="{}"
          :is-saved-card="false"
          @save-table="saveNpsReportTable"
          @save-criteria="buildClientChart"/> 
    </div>
    <div class="row pt-3">
      <h4> Profile Chart</h4>
      <profile-chart-buttons ref="chartButtons" 
        :input-show-labels="eChartCriteria.showLabels"
        :input-show-legend="eChartCriteria.showLegend"
        :input-e-chart-type="eChartCriteria.eChartType" 
        :input-show-goal-line="eChartCriteria.showGoalLine"
        @set-show-goal-line="setShowGoalLine"
        @set-angle-text="setAngleText"
        @set-chart="setChartType"
        @set-display-number-of-responses="setDisplayNumberOfResponses"
        @set-show-legend="setShowLegend"
        @set-show-labels="setShowLabels"
      />
      <profile-chart ref="profileChart"
          :e-chart-mini-id="'profile-chart-mini'"
          :e-chart-id="'profile-chart'"
          :input-report-type-name="'Chart - Net Promoter Score'"
          :modal-id="chartInsightModalId"
          :raw-data="{data: finalNeedsData}" 
          :input-client-chart="{}"
          :is-saved-card="false"
          @save-table="saveNpsReportTable"
          @save-criteria="buildClientChart"/>        
          <!-- 
              :is-saved-card="$parent.$parent.clientChart.clientChartId != 0" 
              :input-client-chart="this.$parent.$parent.clientChart"
          -->
          <user-agreement-modal :modal-id="'user-agreement-modal'" :modal-title="'User License Agreement'" />

    </div>      
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>
<script>
import DataTableMixins from "../mixins/DataTableMixins.vue";
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";

import UserAgreementModal from "../modals/UserAgreementModal.vue";
import PredictiveAnalyticsChart from "../views/echarts/PredictiveAnalyticsChart.vue";
import RanksChart from "../views/echarts/RanksChart.vue";
import TrendsChart from "../views/echarts/TrendsChart.vue";
import ProfileChart from "../views/echarts/ProfileChart.vue";
import ProfileChartButtons from "../components/echarts/ProfileChartButtons.vue";
import ProfileService from "../services/echarts/profile.service";
import TrendsService from "../services/echarts/trends.service";
import RanksService from "../services/echarts/ranks.service";
import UserService from "../services/user.service";
import PredictiveAnalyticsService from "../services/echarts/predictive.analytics.service";
import $ from "jquery";

export default {
  name: "Playground",
  mixins: [AdminMixins, ViewMixins, DataTableMixins],
  components: {ProfileChartButtons,ProfileChart,TrendsChart,RanksChart,UserAgreementModal,PredictiveAnalyticsChart},
  props: {},
  data() {
    return {
      title: "At the Playground",
      subTitle: "At the Playground",
      eChartCriteria: {
          eChartType : "stacked-bar-vertical",
          angleText : true,  
          showGoalLine : true,
          showLegend : true,
          showLabels : true,  
          displayNumberOfResponses: false,
          colorPaletteId : 0
      },
      displayType: "moat",
      displayTypeForTrends: "moat-trends",
      displayTypeForRanks: "moat-ranks",
      displayTypeForPredictiveAnalytics: "predictive-analytics",
      isTrends: true,
      inputForPredictive: {
  "responseMessageLogId": null,
  "duration": 404,
  "title": "Client Financials",
  "message": "Successfully retrieved company predictive analytics",
  "requestMethod": "POST",
  "userId": 1,
  "requestPath": "/api/v1/client/get-detailed-predictive-analytics",
  "requestParameters": "{\"clientCode\":\"VfvVOdOGc4K8XBbXoFF9KxYex9OjXUKY\",\"surveyId\":40883,\"startPeriod\":9201,\"endPeriod\":12350,\"useMetricGrowth\":false,\"useMetricGrowthForSecondary\":false,\"metricGroupId\":268}",
  "completed": "Y",
  "dateCreated": "2024-07-22T21:44:01.577+00:00",
  "dateCompleted": "2024-07-22T21:44:01.981+00:00",
  "statusCode": 200,
  "data": {
    "metricDisplayTypeNameForSecondary": "Currency",
    "startTimePeriod": 9201,
    "needsData": {
      "rowsMap": {
        "rows": [
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column number-of-respondents-column",
              "data": "n=",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "307",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "270",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-border-column",
              "dataClass": "predictive-border-column number-of-respondents-column ",
              "data": "233",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "1808",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "224",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "337",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-border-column",
              "dataClass": "predictive-border-column number-of-respondents-column ",
              "data": "451",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "507",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "451",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "509",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-border-column",
              "dataClass": "predictive-border-column number-of-respondents-column ",
              "data": "451",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "507",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "508",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "450",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-border-column",
              "dataClass": "predictive-border-column number-of-respondents-column ",
              "data": "450",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "506",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "450",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "451",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-border-column",
              "dataClass": "predictive-border-column number-of-respondents-column ",
              "data": "450",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column number-of-respondents-column ",
              "data": "344",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Performance",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.16",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.61",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.61",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.64",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.88",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.95",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.00",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.04",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.18",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.15",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Innovation",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.06",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.89",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.50",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.49",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.55",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.65",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.66",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.06",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.25",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.16",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.08",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Convenience",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.18",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.66",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.35",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.43",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.27",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.34",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.42",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.42",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.85",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.93",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.59",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.84",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.75",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.04",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Pricing Practices",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.16",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.31",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.35",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.63",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.93",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.08",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.18",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.69",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.86",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.43",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.66",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.80",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.13",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Safe To Use",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.99",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.30",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.51",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.75",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.85",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.02",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.96",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.04",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.88",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.88",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.84",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.99",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Product Availability",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.22",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.21",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.53",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.36",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.51",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.65",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.09",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.85",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.02",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.12",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.15",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.22",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Brand Reputation",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.24",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.72",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.53",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.54",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.73",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.98",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.93",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.96",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.89",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.96",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.06",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Workplace Culture",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.90",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.74",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.45",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.49",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.47",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.53",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.59",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.59",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.03",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.74",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.80",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.73",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.74",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.95",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Knowledge-Sharing",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.90",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.57",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.06",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.08",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.14",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.24",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.48",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.74",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.89",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.90",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.55",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.49",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.50",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.86",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Sales Relationship",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.84",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.08",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.68",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.51",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.42",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.66",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.64",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.93",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.86",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.65",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.65",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.61",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.64",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.72",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.76",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Ease of Doing Business",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.96",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.94",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.68",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.25",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.44",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.40",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.47",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.75",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.84",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.66",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.81",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.75",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.71",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.78",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.84",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.88",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Speed of Response",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.98",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.08",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.73",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.68",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.69",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.71",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.76",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.87",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.81",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.96",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "8.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.77",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.78",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.80",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.74",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.98",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Trust",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.02",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.50",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.28",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.26",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.33",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.35",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.50",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.54",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.63",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.91",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.79",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.68",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.03",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.07",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Strictness",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.65",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.85",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.94",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.59",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.41",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.26",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.31",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.25",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.36",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.49",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.94",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.97",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "8.02",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.52",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.32",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.28",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Activity",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.13",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.39",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.83",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.25",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.39",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.44",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.63",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.60",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.58",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.62",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.68",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.86",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.28",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.44",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.94",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.78",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Curiosity",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.36",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.54",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.64",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.19",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.23",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "6.18",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.29",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.46",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.44",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.41",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.51",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "7.23",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "7.10",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.70",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.89",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "6.04",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.50",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.44",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Assurance",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "3.92",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "3.93",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "3.99",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.42",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "3.80",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2019,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "3.90",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "3.99",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.17",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.20",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2020,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "4.76",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.05",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.18",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "5.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2021,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "5.04",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.82",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 2,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.41",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 3,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "4.56",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2022,
              "quarter": 4,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column",
              "data": "4.01",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            },
            {
              "id": 0,
              "year": 2023,
              "quarter": 1,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column",
              "data": "3.98",
              "includeGrowthImpact": true,
              "chartData": {},
              "include": true,
              "includedInGrowthImpact": true
            }
          ]
        ]
      },
      "initialOrderIndex": 1,
      "tableHeader": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-text-column",
          "dataClass": "predictive-column",
          "data": "Satisfaction Averages",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2019",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2020",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2021",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2022",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2023",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        }
      ]
    },
    "metricDisplayTypeName": "Currency",
    "criteriaList": [
      {
        "name": "Period Starts",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "19-Q1 (12/31/2017 - 12/31/2023)"
      },
      {
        "name": "Period Ends",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "23-Q4 (06/30/2022 - 12/31/2023)"
      },
      {
        "name": "Metric",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Revenues TTM"
      }
    ],
    "endTimePeriod": 12350,
    "displaySecondAxisOnTable": true,
    "predictiveAnalyticsData": {
      "rowsMap": {
        "rows": [
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Performance",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "mild-correlation",
              "data": 0.45,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.49,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column very-strong-correlation",
              "data": 0.86,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.67,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.54,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.60",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.89",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.10",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "9.00",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.17",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".83",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Innovation",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.68,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.74,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column very-strong-correlation",
              "data": 0.91,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column very-strong-correlation",
              "data": 0.82,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.71,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.77",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.75",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "5.09",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "9.10",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.97",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "1.13",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Convenience",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.52,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.5,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.69,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.41,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.33,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": "0.49",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.78",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "15.21",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.56",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.18",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".38",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Pricing Practices",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": 0.11,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.15,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.09,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.32,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": -0.22,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "-0.13",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.45",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "13.62",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.75",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.35",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".40",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Safe To Use",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": 0.21,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.33,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.58,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.56,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.52,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": "0.44",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.79",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.77",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.73",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.07",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".66",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Product Availability",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.52,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.56,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column very-strong-correlation",
              "data": 0.8,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.71,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.33,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.58",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.68",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "10.33",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.74",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.19",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".55",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Brand Reputation",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.51,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.61,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column very-strong-correlation",
              "data": 0.8,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.58,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.41,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.58",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.61",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "14.76",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.62",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.24",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".38",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Workplace Culture",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "mild-correlation",
              "data": 0.47,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.43,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.57,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.57,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.42,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": "0.49",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.66",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "6.36",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.72",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.83",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".89",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Knowledge-Sharing",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": 0.22,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.19,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.36,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.36,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.41,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": "0.31",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.51",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "6.12",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.81",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.90",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".90",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Sales Relationship",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": 0.01,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.11,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.31,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.01,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": -0.01,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "0.08",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.42",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "9.34",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.66",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.08",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".58",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Ease of Doing Business",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.55,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.65,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.78,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.55,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.51,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.61",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.77",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.13",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.65",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.94",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".71",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column",
              "data": "Speed of Response",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": 0.2,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.01,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.34,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.25,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": 0.24,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "0.20",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.66",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.75",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.79",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "8.05",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".73",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Trust",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": -0.35,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.15,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.43,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.66,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.66,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "0.25",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.04",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.41",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "6.69",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "6.01",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".68",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Strictness",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": -0.07,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.06,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.1,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.22,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.33,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "0.10",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.96",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "16.56",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "8.30",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "7.94",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".36",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Activity",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "strong-correlation",
              "data": 0.6,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.45,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.49,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.58,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.63,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": "0.55",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.74",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "11.96",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "6.88",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "6.39",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".48",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Curiosity",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": -0.51,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.29,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.01,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": -0.06,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": 0.31,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "-0.11",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.34",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "35.60",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "5.79",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "5.64",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".15",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ],
          [
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-text-column predictive-border-column emotional-needs-column",
              "data": "Assurance",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "",
              "data": -0.1,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": 0.19,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column strong-correlation",
              "data": 0.55,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column mild-correlation",
              "data": 0.41,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column strong-correlation",
              "data": 0.57,
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column mild-correlation",
              "data": "0.32",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "4.73",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "16.31",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-column ",
              "data": "4.27",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": "3.99",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            },
            {
              "id": 0,
              "year": 0,
              "quarter": 0,
              "headerClass": "predictive-column",
              "dataClass": "predictive-border-column ",
              "data": ".29",
              "includeGrowthImpact": false,
              "chartData": {},
              "include": false,
              "includedInGrowthImpact": false
            }
          ]
        ]
      },
      "initialOrderIndex": 1,
      "tableHeader": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-text-column",
          "dataClass": "predictive-column",
          "data": "Satisfaction Averages",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Impact  <br> 23-Q4",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "1-Wave in Future",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "2-Wave in Future",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "3-Wave in Future",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "4-Wave in Future",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "Average Impact",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Pricing Power\r\n23-Q4",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Power Ratio Gap",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Expectations",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Company",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "impact-column",
          "dataClass": "predictive-column",
          "data": "Gap",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        }
      ]
    },
    "useMetricGrowthForSecondary": false,
    "correlation": 0.62,
    "useMetricGrowth": false,
    "chartTitle": "Revenues TTM Impact on Gross Profit TTM",
    "contributionChartList": [
      {
        "charts": [
          {
            "id": 17,
            "text": [],
            "options": {
              "legend": {
                "data": []
              },
              "xAxis": {
                "data": [],
                "type": "category"
              },
              "yAxis": [],
              "series": [
                {
                  "data": [
                    {
                      "name": "Brand Reputation",
                      "value": "15",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Convenience",
                      "value": "15",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Assurance",
                      "value": "17",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Strictness",
                      "value": "17",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Curiosity",
                      "value": "36",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                }
              ]
            },
            "display": true,
            "periodName": "23-Q4",
            "title": "Pricing Power",
            "header": "Average Pricing Power <br/><br/> 5.63%",
            "subTitle": "Best opportunities to raise prices based on current performance levels\t",
            "dataValueColor": "#000"
          },
          {
            "id": 18,
            "text": [],
            "options": {
              "legend": {
                "data": []
              },
              "xAxis": {
                "data": [],
                "type": "category"
              },
              "yAxis": [],
              "series": [
                {
                  "data": [
                    {
                      "name": "Others (2)",
                      "value": "16",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Convenience",
                      "value": "16",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Ease of Doing Business",
                      "value": "18",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Activity",
                      "value": "22",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Innovation",
                      "value": "28",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                }
              ]
            },
            "display": true,
            "periodName": "23-Q4",
            "title": "Revenue Contribution",
            "header": "Revenues TTM<br/><br/>",
            "subTitle": "Strongest performance areas moving in sync to drive growth",
            "dataValueColor": "#000"
          }
        ],
        "snapContainerId": "contribution-snap-id",
        "reportPageTypeName": "Contribution",
        "insightModalId": "contribution-modal-id",
        "periodName": "23-Q4",
        "title": "Contribution"
      },
      {
        "charts": [
          {
            "id": 17,
            "text": [],
            "options": {
              "legend": {
                "data": []
              },
              "xAxis": {
                "data": [],
                "type": "category"
              },
              "yAxis": [],
              "series": [
                {
                  "data": [
                    {
                      "name": "Brand Reputation",
                      "value": "15",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Convenience",
                      "value": "15",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Assurance",
                      "value": "17",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Strictness",
                      "value": "17",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Curiosity",
                      "value": "36",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#008000",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                }
              ]
            },
            "display": true,
            "periodName": "23-Q4",
            "title": "Pricing Power",
            "header": "Average Pricing Power <br/><br/> 5.63%",
            "subTitle": "Best opportunities to raise prices based on current performance levels\t",
            "dataValueColor": "#000"
          },
          {
            "id": 18,
            "text": [],
            "options": {
              "legend": {
                "data": []
              },
              "xAxis": {
                "data": [],
                "type": "category"
              },
              "yAxis": [],
              "series": [
                {
                  "data": [
                    {
                      "name": "Others (2)",
                      "value": "16",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Convenience",
                      "value": "16",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Ease of Doing Business",
                      "value": "18",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Activity",
                      "value": "22",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                },
                {
                  "data": [
                    {
                      "name": "Innovation",
                      "value": "28",
                      "dataValueColor": "#000"
                    }
                  ],
                  "type": "bar",
                  "step": "false",
                  "name": "",
                  "color": "#70AD47",
                  "symbolSize": 12,
                  "itemStyle": {
                    "color": ""
                  },
                  "label": {
                    "show": "false",
                    "color": "#000"
                  },
                  "symbol": ""
                }
              ]
            },
            "display": true,
            "periodName": "23-Q4",
            "title": "Revenue Contribution",
            "header": "Revenues TTM<br/><br/>",
            "subTitle": "Strongest performance areas moving in sync to drive growth",
            "dataValueColor": "#000"
          }
        ],
        "snapContainerId": "future-contribution-snap-id",
        "header": "Revenues TTM<br/><br/>",
        "periodName": "23-Q4",
        "reportPageTypeName": "Chart - Future Contribution",
        "insightModalId": "future-contribution-modal-id1",
        "title": "Revenue Contribution"
      }
    ],
    "metricsData": {
      "metricGrowthRow": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-column",
          "dataClass": "predictive-text-column predictive-border-column company-data-column",
          "data": "Revenues TTM Growth",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.12,
            "displayTypeName": "Currency",
            "wave": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.13,
            "displayTypeName": "Currency",
            "wave": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.17,
            "displayTypeName": "Currency",
            "wave": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.19,
            "displayTypeName": "Currency",
            "wave": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "5.4%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 5.36,
            "metric": 1.18,
            "displayTypeName": "Currency",
            "wave": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-danger ",
          "data": "-6.2%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -6.19,
            "metric": 1.06,
            "displayTypeName": "Currency",
            "wave": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-danger ",
          "data": "-13.7%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -13.68,
            "metric": 1.01,
            "displayTypeName": "Currency",
            "wave": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-danger ",
          "data": "-8.4%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -8.4,
            "metric": 1.09,
            "displayTypeName": "Currency",
            "wave": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-danger ",
          "data": "-5.9%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -5.93,
            "metric": 1.11,
            "displayTypeName": "Currency",
            "wave": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "33.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 33.02,
            "metric": 1.41,
            "displayTypeName": "Currency",
            "wave": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "37.6%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 37.62,
            "metric": 1.39,
            "displayTypeName": "Currency",
            "wave": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "22.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 22.02,
            "metric": 1.33,
            "displayTypeName": "Currency",
            "wave": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "25.2%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 25.23,
            "metric": 1.39,
            "displayTypeName": "Currency",
            "wave": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "6.4%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.38,
            "metric": 1.5,
            "displayTypeName": "Currency",
            "wave": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "8.6%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 8.63,
            "metric": 1.51,
            "displayTypeName": "Currency",
            "wave": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "12.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 12.03,
            "metric": 1.49,
            "displayTypeName": "Currency",
            "wave": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "26.6%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 26.62,
            "metric": 1.76,
            "displayTypeName": "Currency",
            "wave": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        }
      ],
      "metricRow": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-column",
          "dataClass": "predictive-text-column predictive-border-column company-data-column",
          "data": "Revenues TTM",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.12",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.12,
            "displayTypeName": "Currency",
            "wave": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.13",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.13,
            "displayTypeName": "Currency",
            "wave": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.17",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.17,
            "displayTypeName": "Currency",
            "wave": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$1.19",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 1.19,
            "displayTypeName": "Currency",
            "wave": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.18",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 5.36,
            "metric": 1.18,
            "displayTypeName": "Currency",
            "wave": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.06",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -6.19,
            "metric": 1.06,
            "displayTypeName": "Currency",
            "wave": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.01",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -13.68,
            "metric": 1.01,
            "displayTypeName": "Currency",
            "wave": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$1.09",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -8.4,
            "metric": 1.09,
            "displayTypeName": "Currency",
            "wave": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.11",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": -5.93,
            "metric": 1.11,
            "displayTypeName": "Currency",
            "wave": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.41",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 33.02,
            "metric": 1.41,
            "displayTypeName": "Currency",
            "wave": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.39",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 37.62,
            "metric": 1.39,
            "displayTypeName": "Currency",
            "wave": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$1.33",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 22.02,
            "metric": 1.33,
            "displayTypeName": "Currency",
            "wave": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.39",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 25.23,
            "metric": 1.39,
            "displayTypeName": "Currency",
            "wave": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.50",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.38,
            "metric": 1.5,
            "displayTypeName": "Currency",
            "wave": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.51",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 8.63,
            "metric": 1.51,
            "displayTypeName": "Currency",
            "wave": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$1.49",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 12.03,
            "metric": 1.49,
            "displayTypeName": "Currency",
            "wave": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$1.76",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 26.62,
            "metric": 1.76,
            "displayTypeName": "Currency",
            "wave": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        }
      ],
      "secondaryMetricGrowthRow": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-column",
          "dataClass": "predictive-text-column predictive-border-column company-data-column",
          "data": "Gross Profit TTM Growth",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.38,
            "displayTypeName": "Currency",
            "wave": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "7.7%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 7.69,
            "metric": 0.42,
            "displayTypeName": "Currency",
            "wave": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "10.3%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 10.26,
            "metric": 0.43,
            "displayTypeName": "Currency",
            "wave": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "15.8%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 15.79,
            "metric": 0.44,
            "displayTypeName": "Currency",
            "wave": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "7.7%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 7.69,
            "metric": 0.42,
            "displayTypeName": "Currency",
            "wave": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "2.4%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 2.38,
            "metric": 0.43,
            "displayTypeName": "Currency",
            "wave": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "7.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.98,
            "metric": 0.46,
            "displayTypeName": "Currency",
            "wave": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "6.8%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.82,
            "metric": 0.47,
            "displayTypeName": "Currency",
            "wave": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "14.3%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 14.29,
            "metric": 0.48,
            "displayTypeName": "Currency",
            "wave": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "18.6%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 18.6,
            "metric": 0.51,
            "displayTypeName": "Currency",
            "wave": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "13.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 13.04,
            "metric": 0.52,
            "displayTypeName": "Currency",
            "wave": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "17.0%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 17.02,
            "metric": 0.55,
            "displayTypeName": "Currency",
            "wave": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column text-success ",
          "data": "16.7%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 16.67,
            "metric": 0.56,
            "displayTypeName": "Currency",
            "wave": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column text-success ",
          "data": "19.6%",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 19.61,
            "metric": 0.61,
            "displayTypeName": "Currency",
            "wave": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        }
      ],
      "secondaryMetricRow": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-column",
          "dataClass": "predictive-text-column predictive-border-column company-data-column",
          "data": "Gross Profit TTM",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "--",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0,
            "displayTypeName": "--",
            "wave": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.39",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.39",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.38",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.38,
            "displayTypeName": "Currency",
            "wave": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$0.39",
          "includeGrowthImpact": false,
          "chartData": {
            "metricGrowth": 0,
            "metric": 0.39,
            "displayTypeName": "Currency",
            "wave": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.42",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 7.69,
            "metric": 0.42,
            "displayTypeName": "Currency",
            "wave": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.43",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 10.26,
            "metric": 0.43,
            "displayTypeName": "Currency",
            "wave": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.44",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 15.79,
            "metric": 0.44,
            "displayTypeName": "Currency",
            "wave": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$0.42",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 7.69,
            "metric": 0.42,
            "displayTypeName": "Currency",
            "wave": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.43",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 2.38,
            "metric": 0.43,
            "displayTypeName": "Currency",
            "wave": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.46",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.98,
            "metric": 0.46,
            "displayTypeName": "Currency",
            "wave": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.47",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 6.82,
            "metric": 0.47,
            "displayTypeName": "Currency",
            "wave": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$0.48",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 14.29,
            "metric": 0.48,
            "displayTypeName": "Currency",
            "wave": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.51",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 18.6,
            "metric": 0.51,
            "displayTypeName": "Currency",
            "wave": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.52",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 13.04,
            "metric": 0.52,
            "displayTypeName": "Currency",
            "wave": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.55",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 17.02,
            "metric": 0.55,
            "displayTypeName": "Currency",
            "wave": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column",
          "dataClass": "predictive-border-column",
          "data": "$0.56",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 16.67,
            "metric": 0.56,
            "displayTypeName": "Currency",
            "wave": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": true
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "$0.61",
          "includeGrowthImpact": true,
          "chartData": {
            "metricGrowth": 19.61,
            "metric": 0.61,
            "displayTypeName": "Currency",
            "wave": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": true
        }
      ],
      "tableHeader": [
        {
          "id": 0,
          "year": 0,
          "quarter": 0,
          "headerClass": "predictive-text-column predictive-border-column",
          "dataClass": "predictive-column",
          "data": " ",
          "includeGrowthImpact": false,
          "chartData": {},
          "include": false,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2019",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2019,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "19-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2020",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2020,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "20-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2021",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2021,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "21-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2022",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 2,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P2",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q2"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 3,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "P3",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q3"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2022,
          "quarter": 4,
          "headerClass": "predictive-border-column predictive-column",
          "dataClass": "predictive-column",
          "data": "P4",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "22-Q4"
          },
          "include": true,
          "includedInGrowthImpact": false
        },
        {
          "id": 0,
          "year": 2023,
          "quarter": 1,
          "headerClass": "predictive-column",
          "dataClass": "predictive-column",
          "data": "2023",
          "includeGrowthImpact": false,
          "chartData": {
            "displayName": "23-Q1"
          },
          "include": true,
          "includedInGrowthImpact": false
        }
      ]
    },
    "currentTimePeriodName": "23-Q4",
    "metricGroupId": 268,
    "displayCorrelation": true,
    "secondaryMetricGroupId": 269
  }
},
      inputForMoatRanks: [
  {
    "rows": [],
    "cols": [],
    "companyList": {},
    "criteriaList": [],
    "options": {},
    "containerId": "",
    "otherData": {}
  },
  {
    "rows": [
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": false
          },
          {
            "v": "",
            "f": null,
            "include": false
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "-10.0",
            "f": null,
            "include": false
          }
        ]
      },
      {
        "c": [
          {
            "v": "Core Moats",
            "f": null,
            "include": true
          },
          {
            "v": "Value",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "83.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Design",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "53.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Lock-Out",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "93.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Innovation",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "36.667",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Early Mover Moats",
            "f": null,
            "include": true
          },
          {
            "v": "Routine",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "43.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Scale",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "63.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Lock-In",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "20.0",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Network",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "33.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Promise Moats",
            "f": null,
            "include": true
          },
          {
            "v": "Time",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "63.333",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Skill",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "46.667",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": true
          },
          {
            "v": "Brand",
            "f": null,
            "include": true
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "30.0",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "",
            "f": null,
            "include": false
          },
          {
            "v": "",
            "f": null,
            "include": false
          },
          {
            "v": "10.0",
            "f": null,
            "include": false
          },
          {
            "v": "25.0",
            "f": null,
            "include": false
          },
          {
            "v": "40.0",
            "f": null,
            "include": false
          },
          {
            "v": "15.0",
            "f": null,
            "include": false
          },
          {
            "v": "11.0",
            "f": null,
            "include": false
          },
          {
            "v": "-10.0",
            "f": null,
            "include": false
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "need",
        "label": "Moat",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "Sub Moat",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "cb1",
        "label": "color band 1",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "cb1",
        "label": "color band 2",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "cb1",
        "label": "color band 3",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "cb1",
        "label": "color band 4",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "cb1",
        "label": "color band 5",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      }
    ],
    "companyList": {
      "client": [
        {
          "id": 0,
          "name": "RoadRunner",
          "companyId": 40735,
          "companyCode": "940735",
          "sectorId": 0,
          "sectorName": null,
          "isTopCompany": "N",
          "companyType": "client",
          "numberOfResults": 450,
          "imageFileName": null,
          "active": null,
          "color": null,
          "attributes": null,
          "framework": "",
          "discount": false,
          "dateCreated": null,
          "dateModified": null
        }
      ]
    },
    "criteriaList": [
      {
        "name": "Chart Type",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Moats"
      },
      {
        "name": "Time Period",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "22-Q2 (06/30/2021 - 06/30/2022)"
      }
    ],
    "options": {
      "colors": [
        "#f2dcdb",
        "#FFFFC5",
        "#FAFBF7",
        "#EBF1DE",
        "#D8E4BC",
        "#2F5EB3"
      ]
    },
    "containerId": "moats-rank",
    "otherData": {
      "moatsList": [
        {
          "number": "11",
          "name": "Value Chain"
        },
        {
          "number": "10",
          "name": "Design Dominance"
        },
        {
          "number": "7",
          "name": "Channel Lock-Out"
        },
        {
          "number": "1",
          "name": "Distinct Innovation"
        },
        {
          "number": "5",
          "name": "Routine Reliance"
        },
        {
          "number": "9",
          "name": "Economies of Scale"
        },
        {
          "number": "6",
          "name": "Switching Lock-In"
        },
        {
          "number": "4",
          "name": "Network Effect"
        },
        {
          "number": "3",
          "name": "Time Authenticity"
        },
        {
          "number": "8",
          "name": "Economies of Skill"
        },
        {
          "number": "2",
          "name": "Brand Perception"
        },
        {
          "number": "-1",
          "name": "Assurance"
        },
        {
          "number": "-1",
          "name": "Curiosity"
        },
        {
          "number": "-1",
          "name": "Strictness"
        },
        {
          "number": "-1",
          "name": "Trust"
        },
        {
          "number": "-1",
          "name": "Activity"
        }
      ],
      "legend": [
        {
          "elementId": "",
          "name": "RoadRunner <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "blueX heavy",
          "symbolColor": "",
          "column": {
            "id": "need",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 5,
          "visible": true,
          "baseName": "RoadRunner",
          "count": 0
        }
      ],
      "companyColorList": [
        {
          "color": "#2F5EB3",
          "companyName": "Ideal"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Importance"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Expectations"
        },
        {
          "color": "#2F5EB3",
          "companyName": "RoadRunner"
        },
        {
          "color": "#F7CE08",
          "companyName": "Premium"
        },
        {
          "color": "#D43B2D",
          "companyName": "Discount"
        },
        {
          "color": "#2DA2D4",
          "companyName": "Challenger"
        },
        {
          "color": "#8A2DD4",
          "companyName": "Value"
        }
      ]
    }
  }
      ],
      inputDataForTrends: [
  {
    "rows": [
      {
        "c": [
          {
            "v": "22-Q2 (n=450)",
            "f": null,
            "include": true
          },
          {
            "v": "3.574",
            "f": null,
            "include": true
          },
          {
            "v": "8.702",
            "f": null,
            "include": true
          },
          {
            "v": "7.806",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "22-Q3 (n=451)",
            "f": null,
            "include": true
          },
          {
            "v": "3.593",
            "f": null,
            "include": true
          },
          {
            "v": "8.749",
            "f": null,
            "include": true
          },
          {
            "v": "7.881",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "22-Q4 (n=450)",
            "f": null,
            "include": true
          },
          {
            "v": "4.457",
            "f": null,
            "include": true
          },
          {
            "v": "8.706",
            "f": null,
            "include": true
          },
          {
            "v": "7.836",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "23-Q1 (n=344)",
            "f": null,
            "include": true
          },
          {
            "v": "5.028",
            "f": null,
            "include": true
          },
          {
            "v": "8.773",
            "f": null,
            "include": true
          },
          {
            "v": "8.024",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "23-Q2 (n=307)",
            "f": null,
            "include": true
          },
          {
            "v": "5.158",
            "f": null,
            "include": true
          },
          {
            "v": "8.756",
            "f": null,
            "include": true
          },
          {
            "v": "8.026",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "23-Q3 (n=270)",
            "f": null,
            "include": true
          },
          {
            "v": "5.4",
            "f": null,
            "include": true
          },
          {
            "v": "8.756",
            "f": null,
            "include": true
          },
          {
            "v": "8.078",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "23-Q4 (n=233)",
            "f": null,
            "include": true
          },
          {
            "v": "5.631",
            "f": null,
            "include": true
          },
          {
            "v": "8.758",
            "f": null,
            "include": true
          },
          {
            "v": "8.08",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "2024 - P1 (n=0)",
            "f": null,
            "include": true
          },
          {
            "v": ".0",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "2024 - P2 (n=0)",
            "f": null,
            "include": true
          },
          {
            "v": ".0",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "2024 - P3 (n=0)",
            "f": null,
            "include": true
          },
          {
            "v": ".0",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "2024 - P4 (n=0)",
            "f": null,
            "include": true
          },
          {
            "v": ".0",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "--",
            "f": null,
            "include": true
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "year",
        "label": "Time Period",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "competitive-trends",
        "label": "Pricing Power (Bar)",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "grower-expectations",
        "label": "Importance",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "competitive-trends",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      }
    ],
    "companyList": {
      "client": [
        {
          "id": 0,
          "name": "RoadRunner",
          "companyId": 40735,
          "companyCode": "940735",
          "sectorId": 0,
          "sectorName": null,
          "isTopCompany": "N",
          "companyType": "client",
          "numberOfResults": 450,
          "imageFileName": null,
          "active": null,
          "color": null,
          "attributes": null,
          "framework": "",
          "discount": false,
          "dateCreated": null,
          "dateModified": null
        }
      ]
    },
    "criteriaList": [
      {
        "name": "Performance",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Summary"
      },
      {
        "name": "Time Period",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "22-Q2 (06/30/2021 - 06/30/2022)"
      }
    ],
    "options": {
      "companyId": 38175,
      "title": "Summary",
      "colors": [
        "#D7E4BD",
        "#2F5EB3",
        "#2F5EB3"
      ]
    },
    "containerId": "competitive-trends",
    "otherData": {
      "breakPointList": [
        2,
        6
      ],
      "useCurrency": false,
      "overrideTicks": false,
      "legend": [
        {
          "elementId": "thick",
          "name": "Pricing Power (Bar)",
          "symbolClass": "line thick",
          "symbolColor": "#D7E4BD",
          "column": {
            "id": "competitive-trends",
            "label": "Pricing Power (Bar)",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 0,
          "visible": true,
          "baseName": "Pricing Power (Bar)",
          "count": 0
        },
        {
          "elementId": "",
          "name": "Importance",
          "symbolClass": "line",
          "symbolColor": "#2F5EB3",
          "column": {
            "id": "grower-expectations",
            "label": "Importance",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 1,
          "visible": true,
          "baseName": "Importance",
          "count": 0
        },
        {
          "elementId": "",
          "name": "RoadRunner",
          "symbolClass": "line",
          "symbolColor": "#2F5EB3",
          "column": {
            "id": "competitive-trends",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 2,
          "visible": true,
          "baseName": "RoadRunner",
          "count": 0
        }
      ],
      "npsChartDataByTimePeriod": [],
      "vAxisForMetric": {
        "minValue": 0,
        "maxValue": 0.045,
        "format": "#'%'",
        "formatter": "{value}%",
        "viewWindow": {
          "min": 0
        }
      },
      "usePercentage": true,
      "emotionalNeedSelected": false,
      "vAxisForPerformance": {
        "minValue": 1,
        "maxValue": 10,
        "format": null,
        "formatter": null,
        "viewWindow": {
          "min": 1
        }
      },
      "companyColorList": [
        {
          "color": "#2F5EB3",
          "companyName": "Ideal"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Importance"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Expectations"
        },
        {
          "color": "#2F5EB3",
          "companyName": "RoadRunner"
        },
        {
          "color": "#F7CE08",
          "companyName": "Premium"
        },
        {
          "color": "#D43B2D",
          "companyName": "Discount"
        },
        {
          "color": "#2DA2D4",
          "companyName": "Challenger"
        },
        {
          "color": "#8A2DD4",
          "companyName": "Value"
        }
      ]
    }
  }
      ],
      inputDataForMatchWinner: [],
      inputDataForMatchMoat: [],      
      inputDataForMatchValue: [],      
      inputDataForMatchNeed: [],
      inputDataForValue: [],      
      inputDataForMoat:[
  {
    "rows": [
      {
        "c": [
          {
            "v": "Value Chain",
            "f": null,
            "include": true
          },
          {
            "v": "Pricing Practices",
            "f": null,
            "include": true
          },
          {
            "v": "1.099",
            "f": null,
            "include": true
          },
          {
            "v": "8.562",
            "f": null,
            "include": true
          },
          {
            "v": "7.463",
            "f": null,
            "include": true
          },
          {
            "v": "3.68",
            "f": null,
            "include": true
          },
          {
            "v": "3.35",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "--",
            "f": null,
            "include": true
          },
          {
            "v": "Convenience",
            "f": null,
            "include": true
          },
          {
            "v": "1.049",
            "f": null,
            "include": true
          },
          {
            "v": "8.647",
            "f": null,
            "include": true
          },
          {
            "v": "7.597",
            "f": null,
            "include": true
          },
          {
            "v": "3.55",
            "f": null,
            "include": true
          },
          {
            "v": "3.38",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Design Dominance",
            "f": null,
            "include": true
          },
          {
            "v": "Performance",
            "f": null,
            "include": true
          },
          {
            "v": ".978",
            "f": null,
            "include": true
          },
          {
            "v": "9.02",
            "f": null,
            "include": true
          },
          {
            "v": "8.042",
            "f": null,
            "include": true
          },
          {
            "v": "3.66",
            "f": null,
            "include": true
          },
          {
            "v": "3.73",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Channel Lock-Out",
            "f": null,
            "include": true
          },
          {
            "v": "Safe To Use",
            "f": null,
            "include": true
          },
          {
            "v": ".779",
            "f": null,
            "include": true
          },
          {
            "v": "8.647",
            "f": null,
            "include": true
          },
          {
            "v": "7.868",
            "f": null,
            "include": true
          },
          {
            "v": "3.82",
            "f": null,
            "include": true
          },
          {
            "v": "4.90",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Distinct Innovation",
            "f": null,
            "include": true
          },
          {
            "v": "Innovation",
            "f": null,
            "include": true
          },
          {
            "v": ".904",
            "f": null,
            "include": true
          },
          {
            "v": "9.064",
            "f": null,
            "include": true
          },
          {
            "v": "8.16",
            "f": null,
            "include": true
          },
          {
            "v": "3.66",
            "f": null,
            "include": true
          },
          {
            "v": "4.07",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Routine Reliance",
            "f": null,
            "include": true
          },
          {
            "v": "Ease of Doing Business",
            "f": null,
            "include": true
          },
          {
            "v": ".669",
            "f": null,
            "include": true
          },
          {
            "v": "8.451",
            "f": null,
            "include": true
          },
          {
            "v": "7.782",
            "f": null,
            "include": true
          },
          {
            "v": "3.83",
            "f": null,
            "include": true
          },
          {
            "v": "5.72",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Economies of Scale",
            "f": null,
            "include": true
          },
          {
            "v": "Product Availability",
            "f": null,
            "include": true
          },
          {
            "v": ".806",
            "f": null,
            "include": true
          },
          {
            "v": "8.927",
            "f": null,
            "include": true
          },
          {
            "v": "8.12",
            "f": null,
            "include": true
          },
          {
            "v": "3.59",
            "f": null,
            "include": true
          },
          {
            "v": "4.43",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Switching Lock-In",
            "f": null,
            "include": true
          },
          {
            "v": "Sales Relationship",
            "f": null,
            "include": true
          },
          {
            "v": ".927",
            "f": null,
            "include": true
          },
          {
            "v": "8.531",
            "f": null,
            "include": true
          },
          {
            "v": "7.604",
            "f": null,
            "include": true
          },
          {
            "v": "3.58",
            "f": null,
            "include": true
          },
          {
            "v": "3.85",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Network Effect",
            "f": null,
            "include": true
          },
          {
            "v": "Knowledge-Sharing",
            "f": null,
            "include": true
          },
          {
            "v": "1.172",
            "f": null,
            "include": true
          },
          {
            "v": "8.662",
            "f": null,
            "include": true
          },
          {
            "v": "7.49",
            "f": null,
            "include": true
          },
          {
            "v": "3.62",
            "f": null,
            "include": true
          },
          {
            "v": "3.09",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Time Authenticity",
            "f": null,
            "include": true
          },
          {
            "v": "Speed of Response",
            "f": null,
            "include": true
          },
          {
            "v": ".898",
            "f": null,
            "include": true
          },
          {
            "v": "8.673",
            "f": null,
            "include": true
          },
          {
            "v": "7.776",
            "f": null,
            "include": true
          },
          {
            "v": "3.90",
            "f": null,
            "include": true
          },
          {
            "v": "4.33",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Economies of Skill",
            "f": null,
            "include": true
          },
          {
            "v": "Workplace Culture",
            "f": null,
            "include": true
          },
          {
            "v": ".82",
            "f": null,
            "include": true
          },
          {
            "v": "8.622",
            "f": null,
            "include": true
          },
          {
            "v": "7.802",
            "f": null,
            "include": true
          },
          {
            "v": "3.70",
            "f": null,
            "include": true
          },
          {
            "v": "4.51",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Brand Perception",
            "f": null,
            "include": true
          },
          {
            "v": "Brand Reputation",
            "f": null,
            "include": true
          },
          {
            "v": ".655",
            "f": null,
            "include": true
          },
          {
            "v": "8.62",
            "f": null,
            "include": true
          },
          {
            "v": "7.965",
            "f": null,
            "include": true
          },
          {
            "v": "3.38",
            "f": null,
            "include": true
          },
          {
            "v": "5.12",
            "f": null,
            "include": true
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "moat1",
        "label": "Moat",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "Need",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "gap",
        "label": "Gap",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "customer-expectations",
        "label": "Expectations",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power",
        "label": "Pricing Power",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power-gap",
        "label": "Power Ratio Gap",
        "type": "string",
        "className": "dt-right"
      }
    ],
    "companyList": {
      "client": [
        {
          "id": 0,
          "name": "RoadRunner",
          "companyId": 40735,
          "companyCode": "940735",
          "sectorId": 0,
          "sectorName": null,
          "isTopCompany": "N",
          "companyType": "client",
          "numberOfResults": 450,
          "imageFileName": null,
          "active": null,
          "color": null,
          "attributes": null,
          "framework": "",
          "discount": false,
          "dateCreated": null,
          "dateModified": null
        }
      ]
    },
    "criteriaList": [
      {
        "name": "Show Pricing Power",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Yes"
      },
      {
        "name": "Chart Type",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Moat"
      },
      {
        "name": "Time Period",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "22-Q2 (06/30/2021 - 06/30/2022)"
      }
    ],
    "options": {
      "title": "Moat",
      "colors": [
        "#D7E4BD",
        "#2F5EB3",
        "#2F5EB3"
      ]
    },
    "containerId": "moat_functional_needs_chart",
    "otherData": {
      "breakPointList": [
        8
      ],
      "pricingPowerSeries": {
        "targetAxisIndex": 1,
        "type": "bars"
      },
      "moatsList": [
        {
          "number": "11",
          "name": "Value Chain"
        },
        {
          "number": "10",
          "name": "Design Dominance"
        },
        {
          "number": "7",
          "name": "Channel Lock-Out"
        },
        {
          "number": "1",
          "name": "Distinct Innovation"
        },
        {
          "number": "5",
          "name": "Routine Reliance"
        },
        {
          "number": "9",
          "name": "Economies of Scale"
        },
        {
          "number": "6",
          "name": "Switching Lock-In"
        },
        {
          "number": "4",
          "name": "Network Effect"
        },
        {
          "number": "3",
          "name": "Time Authenticity"
        },
        {
          "number": "8",
          "name": "Economies of Skill"
        },
        {
          "number": "2",
          "name": "Brand Perception"
        },
        {
          "number": "-1",
          "name": "Assurance"
        },
        {
          "number": "-1",
          "name": "Curiosity"
        },
        {
          "number": "-1",
          "name": "Strictness"
        },
        {
          "number": "-1",
          "name": "Trust"
        },
        {
          "number": "-1",
          "name": "Activity"
        }
      ],
      "barList": [
        {
          "className": "bar bar-0",
          "backgroundColor": "#2F5EB3",
          "index": 2,
          "seriesIndex": 3
        }
      ],
      "legend": [
        {
          "elementId": "bar-0",
          "name": "Expectations <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "bar",
          "symbolColor": "#2F5EB3",
          "column": {
            "id": "customer-expectations",
            "label": "Expectations",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 1,
          "visible": true,
          "baseName": "Expectations",
          "count": 450
        },
        {
          "elementId": "blueX",
          "name": "RoadRunner <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "blueX heavy",
          "symbolColor": "",
          "column": {
            "id": "need",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 2,
          "visible": true,
          "baseName": "RoadRunner",
          "count": 450
        },
        {
          "elementId": "thick",
          "name": "Pricing Power (Bar)",
          "symbolClass": "line thick",
          "symbolColor": "#D7E4BD",
          "column": {
            "id": "competitive-trends",
            "label": "Pricing Power (Bar)",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 3,
          "visible": true,
          "baseName": "Pricing Power (Bar)",
          "count": 0
        }
      ],
      "pricingPowerViewWindowMax": 5,
      "needsList": [
        {
          "needName": "Pricing Practices",
          "needNumber": "4"
        },
        {
          "needName": "Convenience",
          "needNumber": "3"
        },
        {
          "needName": "Performance",
          "needNumber": "1"
        },
        {
          "needName": "Safe To Use",
          "needNumber": "5"
        },
        {
          "needName": "Innovation",
          "needNumber": "2"
        },
        {
          "needName": "Ease of Doing Business",
          "needNumber": "11"
        },
        {
          "needName": "Product Availability",
          "needNumber": "6"
        },
        {
          "needName": "Sales Relationship",
          "needNumber": "10"
        },
        {
          "needName": "Knowledge-Sharing",
          "needNumber": "9"
        },
        {
          "needName": "Speed of Response",
          "needNumber": "12"
        },
        {
          "needName": "Workplace Culture",
          "needNumber": "8"
        },
        {
          "needName": "Brand Reputation",
          "needNumber": "7"
        },
        {
          "needName": "Stable, Anxious",
          "needNumber": "5"
        },
        {
          "needName": "Imaginative, Practical",
          "needNumber": "4"
        },
        {
          "needName": "Precise, Flexible",
          "needNumber": "2"
        },
        {
          "needName": "Like-Minded, Tough-Minded",
          "needNumber": "1"
        },
        {
          "needName": "Connected, Detached",
          "needNumber": "3"
        }
      ],
      "pricingPowerSeriesNumber": 3,
      "moatMapDataList": [
        {
          "name": "Value Chain",
          "number": "1",
          "performanceAssessment": [
            {
              "name": "Convenience",
              "gap": "1.049",
              "pricingPower": 3.55,
              "pricingPowerRankGroup": 3,
              "gapGroup": 3,
              "gapRank": 0
            },
            {
              "name": " Anxious",
              "gap": ".145",
              "pricingPower": 3.8,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Pricing Practices",
              "gap": "1.099",
              "pricingPower": 3.68,
              "pricingPowerRankGroup": 3,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": " Anxious",
              "intensityGap": 0.9470000000000001,
              "dissonanceGap": 0.145,
              "importance": 0,
              "intensityGapRank": 4,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.6045,
          "importanceRank": 9,
          "dissonanceGap": 0.6094999999999999,
          "dissonanceGapRank": 2,
          "pricingPower": 3.676666666666667,
          "pricingPowerRankGroup": 3
        },
        {
          "name": "Design Dominance",
          "number": "2",
          "performanceAssessment": [
            {
              "name": "Performance",
              "gap": ".978",
              "pricingPower": 3.66,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Imaginative",
              "gap": "-.585",
              "pricingPower": 4.12,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": " Practical",
              "intensityGap": 0.19899999999999984,
              "dissonanceGap": 0.585,
              "importance": 0,
              "intensityGapRank": 5,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 9.02,
          "importanceRank": 2,
          "dissonanceGap": 0.7815,
          "dissonanceGapRank": 8,
          "pricingPower": 3.89,
          "pricingPowerRankGroup": 1
        },
        {
          "name": "Channel Lock-Out",
          "number": "3",
          "performanceAssessment": [
            {
              "name": "Safe To Use",
              "gap": ".779",
              "pricingPower": 3.82,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Stable",
              "gap": ".145",
              "pricingPower": 3.8,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": " Anxious",
              "intensityGap": 0.9470000000000001,
              "dissonanceGap": 0.145,
              "importance": 0,
              "intensityGapRank": 4,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.647,
          "importanceRank": 6,
          "dissonanceGap": 0.462,
          "dissonanceGapRank": 1,
          "pricingPower": 3.8099999999999996,
          "pricingPowerRankGroup": 1
        },
        {
          "name": "Distinct Innovation",
          "number": "4",
          "performanceAssessment": [
            {
              "name": "Innovation",
              "gap": ".904",
              "pricingPower": 3.66,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Imaginative",
              "gap": "-.585",
              "pricingPower": 4.12,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": " Practical",
              "intensityGap": 0.19899999999999984,
              "dissonanceGap": 0.585,
              "importance": 0,
              "intensityGapRank": 5,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 9.064,
          "importanceRank": 1,
          "dissonanceGap": 0.7444999999999999,
          "dissonanceGapRank": 7,
          "pricingPower": 3.89,
          "pricingPowerRankGroup": 1
        },
        {
          "name": "Routine Reliance",
          "number": "5",
          "performanceAssessment": [
            {
              "name": "Ease of Doing Business",
              "gap": ".669",
              "pricingPower": 3.83,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": " Practical",
              "gap": "-.585",
              "pricingPower": 4.12,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": " Practical",
              "intensityGap": 0.19899999999999984,
              "dissonanceGap": 0.585,
              "importance": 0,
              "intensityGapRank": 5,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.451,
          "importanceRank": 11,
          "dissonanceGap": 0.627,
          "dissonanceGapRank": 3,
          "pricingPower": 3.975,
          "pricingPowerRankGroup": 1
        },
        {
          "name": "Economies of Scale",
          "number": "6",
          "performanceAssessment": [
            {
              "name": "Product Availability",
              "gap": ".806",
              "pricingPower": 3.59,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": " Flexible",
              "gap": ".461",
              "pricingPower": 3.75,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Precise",
              "intensityGap": 2.2809999999999997,
              "dissonanceGap": 0.461,
              "importance": 0,
              "intensityGapRank": 2,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.927,
          "importanceRank": 3,
          "dissonanceGap": 0.6335000000000001,
          "dissonanceGapRank": 4,
          "pricingPower": 3.67,
          "pricingPowerRankGroup": 3
        },
        {
          "name": "Switching Lock-In",
          "number": "7",
          "performanceAssessment": [
            {
              "name": "Sales Relationship",
              "gap": ".927",
              "pricingPower": 3.58,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": " Tough-Minded",
              "gap": "1.167",
              "pricingPower": 3.76,
              "pricingPowerRankGroup": 2,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Like-Minded",
              "intensityGap": 2.346,
              "dissonanceGap": 1.167,
              "importance": 0,
              "intensityGapRank": 1,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.531,
          "importanceRank": 10,
          "dissonanceGap": 1.0470000000000002,
          "dissonanceGapRank": 10,
          "pricingPower": 3.67,
          "pricingPowerRankGroup": 3
        },
        {
          "name": "Network Effect",
          "number": "8",
          "performanceAssessment": [
            {
              "name": "Knowledge-Sharing",
              "gap": "1.172",
              "pricingPower": 3.62,
              "pricingPowerRankGroup": 3,
              "gapGroup": 3,
              "gapRank": 0
            },
            {
              "name": "Connected",
              "gap": ".988",
              "pricingPower": 3.78,
              "pricingPowerRankGroup": 2,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Connected",
              "intensityGap": 1.4290000000000003,
              "dissonanceGap": 0.988,
              "importance": 0,
              "intensityGapRank": 3,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.662,
          "importanceRank": 5,
          "dissonanceGap": 1.08,
          "dissonanceGapRank": 11,
          "pricingPower": 3.7,
          "pricingPowerRankGroup": 2
        },
        {
          "name": "Time Authenticity",
          "number": "9",
          "performanceAssessment": [
            {
              "name": "Speed of Response",
              "gap": ".898",
              "pricingPower": 3.9,
              "pricingPowerRankGroup": 1,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Precise",
              "gap": ".461",
              "pricingPower": 3.75,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Precise",
              "intensityGap": 2.2809999999999997,
              "dissonanceGap": 0.461,
              "importance": 0,
              "intensityGapRank": 2,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.673,
          "importanceRank": 4,
          "dissonanceGap": 0.6795,
          "dissonanceGapRank": 6,
          "pricingPower": 3.825,
          "pricingPowerRankGroup": 1
        },
        {
          "name": "Economies of Skill",
          "number": "10",
          "performanceAssessment": [
            {
              "name": "Workplace Culture",
              "gap": ".82",
              "pricingPower": 3.7,
              "pricingPowerRankGroup": 2,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Precise",
              "gap": ".461",
              "pricingPower": 3.75,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Precise",
              "intensityGap": 2.2809999999999997,
              "dissonanceGap": 0.461,
              "importance": 0,
              "intensityGapRank": 2,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.622,
          "importanceRank": 7,
          "dissonanceGap": 0.6405,
          "dissonanceGapRank": 5,
          "pricingPower": 3.725,
          "pricingPowerRankGroup": 2
        },
        {
          "name": "Brand Perception",
          "number": "11",
          "performanceAssessment": [
            {
              "name": "Brand Reputation",
              "gap": ".655",
              "pricingPower": 3.38,
              "pricingPowerRankGroup": 3,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Like-Minded",
              "gap": "1.167",
              "pricingPower": 3.76,
              "pricingPowerRankGroup": 2,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Like-Minded",
              "intensityGap": 2.346,
              "dissonanceGap": 1.167,
              "importance": 0,
              "intensityGapRank": 1,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "importance": 8.62,
          "importanceRank": 8,
          "dissonanceGap": 0.911,
          "dissonanceGapRank": 9,
          "pricingPower": 3.57,
          "pricingPowerRankGroup": 3
        }
      ],
      "companyColorList": [
        {
          "color": "#2F5EB3",
          "companyName": "Ideal"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Importance"
        },
        {
          "color": "#2F5EB3",
          "companyName": "Expectations"
        },
        {
          "color": "#2F5EB3",
          "companyName": "RoadRunner"
        },
        {
          "color": "#F7CE08",
          "companyName": "Premium"
        },
        {
          "color": "#D43B2D",
          "companyName": "Discount"
        },
        {
          "color": "#2DA2D4",
          "companyName": "Challenger"
        },
        {
          "color": "#8A2DD4",
          "companyName": "Value"
        }
      ]
    }
  },
  {
    "rows": [
      {
        "c": [
          {
            "v": "Assurance",
            "f": null,
            "include": true
          },
          {
            "v": "Stable, Anxious",
            "f": null,
            "include": true
          },
          {
            "v": ".145",
            "f": null,
            "include": true
          },
          {
            "v": "4.553",
            "f": null,
            "include": true
          },
          {
            "v": "4.409",
            "f": null,
            "include": true
          },
          {
            "v": "3.80",
            "f": null,
            "include": true
          },
          {
            "v": "27.14",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Curiosity",
            "f": null,
            "include": true
          },
          {
            "v": "Imaginative, Practical",
            "f": null,
            "include": true
          },
          {
            "v": "-.585",
            "f": null,
            "include": true
          },
          {
            "v": "5.301",
            "f": null,
            "include": true
          },
          {
            "v": "5.886",
            "f": null,
            "include": true
          },
          {
            "v": "4.12",
            "f": null,
            "include": true
          },
          {
            "v": "7.12",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Strictness",
            "f": null,
            "include": true
          },
          {
            "v": "Precise, Flexible",
            "f": null,
            "include": true
          },
          {
            "v": ".461",
            "f": null,
            "include": true
          },
          {
            "v": "7.781",
            "f": null,
            "include": true
          },
          {
            "v": "7.32",
            "f": null,
            "include": true
          },
          {
            "v": "3.75",
            "f": null,
            "include": true
          },
          {
            "v": "8.15",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Trust",
            "f": null,
            "include": true
          },
          {
            "v": "Like-Minded, Tough-Minded",
            "f": null,
            "include": true
          },
          {
            "v": "1.167",
            "f": null,
            "include": true
          },
          {
            "v": "7.846",
            "f": null,
            "include": true
          },
          {
            "v": "6.679",
            "f": null,
            "include": true
          },
          {
            "v": "3.76",
            "f": null,
            "include": true
          },
          {
            "v": "3.21",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "Activity",
            "f": null,
            "include": true
          },
          {
            "v": "Connected, Detached",
            "f": null,
            "include": true
          },
          {
            "v": ".988",
            "f": null,
            "include": true
          },
          {
            "v": "6.929",
            "f": null,
            "include": true
          },
          {
            "v": "5.941",
            "f": null,
            "include": true
          },
          {
            "v": "3.78",
            "f": null,
            "include": true
          },
          {
            "v": "3.82",
            "f": null,
            "include": true
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "moat1",
        "label": "Moat",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "Need",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "gap",
        "label": "Gap",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "customer-expectations",
        "label": "Expectations",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power",
        "label": "Pricing Power",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power-gap",
        "label": "Power Ratio Gap",
        "type": "string",
        "className": "dt-right"
      }
    ],
    "companyList": {},
    "criteriaList": [],
    "options": {
      "colors": [
        "#D7E4BD",
        "#2F5EB3",
        "#2F5EB3"
      ]
    },
    "containerId": "moat_emotional_needs_chart",
    "otherData": {}
  }
      ],
      inputDataForWinner: [],      
      drawChart: false,
      chartInsightModalId: "",
      hasChartRun: true,
      displayPricingPower: true,
      inputDataForNeed: [
  {
    "rows": [
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Performance",
            "f": null,
            "include": true
          },
          {
            "v": "1.006",
            "f": null,
            "include": true
          },
          {
            "v": "9.178",
            "f": null,
            "include": true
          },
          {
            "v": "8.172",
            "f": null,
            "include": true
          },
          {
            "v": "3.44",
            "f": null,
            "include": true
          },
          {
            "v": "3.41",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Product Availability",
            "f": null,
            "include": true
          },
          {
            "v": "1.092",
            "f": null,
            "include": true
          },
          {
            "v": "9.111",
            "f": null,
            "include": true
          },
          {
            "v": "8.019",
            "f": null,
            "include": true
          },
          {
            "v": "3.30",
            "f": null,
            "include": true
          },
          {
            "v": "3.03",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Innovation",
            "f": null,
            "include": true
          },
          {
            "v": ".787",
            "f": null,
            "include": true
          },
          {
            "v": "9.033",
            "f": null,
            "include": true
          },
          {
            "v": "8.246",
            "f": null,
            "include": true
          },
          {
            "v": "3.57",
            "f": null,
            "include": true
          },
          {
            "v": "4.52",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Speed of Response",
            "f": null,
            "include": true
          },
          {
            "v": ".945",
            "f": null,
            "include": true
          },
          {
            "v": "8.951",
            "f": null,
            "include": true
          },
          {
            "v": "8.006",
            "f": null,
            "include": true
          },
          {
            "v": "3.44",
            "f": null,
            "include": true
          },
          {
            "v": "3.66",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Convenience",
            "f": null,
            "include": true
          },
          {
            "v": "1.033",
            "f": null,
            "include": true
          },
          {
            "v": "8.906",
            "f": null,
            "include": true
          },
          {
            "v": "7.873",
            "f": null,
            "include": true
          },
          {
            "v": "3.41",
            "f": null,
            "include": true
          },
          {
            "v": "3.31",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Safe To Use",
            "f": null,
            "include": true
          },
          {
            "v": ".861",
            "f": null,
            "include": true
          },
          {
            "v": "8.897",
            "f": null,
            "include": true
          },
          {
            "v": "8.036",
            "f": null,
            "include": true
          },
          {
            "v": "3.38",
            "f": null,
            "include": true
          },
          {
            "v": "3.93",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Knowledge-Sharing",
            "f": null,
            "include": true
          },
          {
            "v": ".91",
            "f": null,
            "include": true
          },
          {
            "v": "8.811",
            "f": null,
            "include": true
          },
          {
            "v": "7.901",
            "f": null,
            "include": true
          },
          {
            "v": "3.35",
            "f": null,
            "include": true
          },
          {
            "v": "3.68",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Brand Reputation",
            "f": null,
            "include": true
          },
          {
            "v": ".803",
            "f": null,
            "include": true
          },
          {
            "v": "8.759",
            "f": null,
            "include": true
          },
          {
            "v": "7.957",
            "f": null,
            "include": true
          },
          {
            "v": "3.33",
            "f": null,
            "include": true
          },
          {
            "v": "4.16",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Workplace Culture",
            "f": null,
            "include": true
          },
          {
            "v": ".765",
            "f": null,
            "include": true
          },
          {
            "v": "8.678",
            "f": null,
            "include": true
          },
          {
            "v": "7.913",
            "f": null,
            "include": true
          },
          {
            "v": "3.41",
            "f": null,
            "include": true
          },
          {
            "v": "4.49",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Pricing Practices",
            "f": null,
            "include": true
          },
          {
            "v": "1.041",
            "f": null,
            "include": true
          },
          {
            "v": "8.646",
            "f": null,
            "include": true
          },
          {
            "v": "7.605",
            "f": null,
            "include": true
          },
          {
            "v": "3.58",
            "f": null,
            "include": true
          },
          {
            "v": "3.44",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Sales Relationship",
            "f": null,
            "include": true
          },
          {
            "v": "1.036",
            "f": null,
            "include": true
          },
          {
            "v": "8.642",
            "f": null,
            "include": true
          },
          {
            "v": "7.606",
            "f": null,
            "include": true
          },
          {
            "v": "3.49",
            "f": null,
            "include": true
          },
          {
            "v": "3.36",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Ease of Doing Business",
            "f": null,
            "include": true
          },
          {
            "v": ".867",
            "f": null,
            "include": true
          },
          {
            "v": "8.612",
            "f": null,
            "include": true
          },
          {
            "v": "7.746",
            "f": null,
            "include": true
          },
          {
            "v": "3.59",
            "f": null,
            "include": true
          },
          {
            "v": "4.13",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "1",
            "f": null,
            "include": true
          },
          {
            "v": "Average",
            "f": null,
            "include": true
          },
          {
            "v": ".929",
            "f": null,
            "include": true
          },
          {
            "v": "8.852",
            "f": null,
            "include": true
          },
          {
            "v": "7.923",
            "f": null,
            "include": true
          },
          {
            "v": "3.441",
            "f": null,
            "include": true
          },
          {
            "v": "3.76",
            "f": null,
            "include": true
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "sort",
        "label": "",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "Need",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "gap",
        "label": "Gap",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "customer-expectations",
        "label": "Expectations",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power",
        "label": "Pricing Power",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power-gap",
        "label": "Power Ratio Gap",
        "type": "string",
        "className": "dt-right"
      }
    ],
    "companyList": {
      "client": [
        {
          "id": 0,
          "name": "RoadRunner",
          "companyId": 40735,
          "companyCode": "940735",
          "sectorId": 0,
          "sectorName": null,
          "isTopCompany": "N",
          "companyType": "client",
          "numberOfResults": 450,
          "imageFileName": null,
          "active": null,
          "color": null,
          "attributes": null,
          "framework": "",
          "discount": false,
          "dateCreated": null,
          "dateModified": null
        }
      ]
    },
    "criteriaList": [
      {
        "name": "Show Pricing Power",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Yes"
      },
      {
        "name": "Chart Type",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Needs"
      },
      {
        "name": "Time Period",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "21-Q4 (12/31/2020 - 12/31/2021)"
      }
    ],
    "options": {
      "colors": [
        "#D7E4BD",
        "#008000",
        "#2F5EB3"
      ]
    },
    "containerId": "functional_needs_chart",
    "otherData": {
      "breakPointList": [
        2,
        5,
        8
      ],
      "pricingPowerSeries": {
        "targetAxisIndex": 1,
        "type": "bars"
      },
      "barList": [
        {
          "className": "bar bar-0",
          "backgroundColor": "#008000",
          "index": 2,
          "seriesIndex": 3
        }
      ],
      "npsDataTable": {
        "rows": [
          {
            "c": [
              {
                "v": "n=",
                "f": null,
                "include": true
              },
              {
                "v": "449",
                "f": null,
                "include": true
              }
            ]
          },
          {
            "c": [
              {
                "v": "NPS",
                "f": null,
                "include": true
              },
              {
                "v": "37.4",
                "f": null,
                "include": true
              }
            ]
          },
          {
            "c": [
              {
                "v": "Promoters",
                "f": null,
                "include": true
              },
              {
                "v": "52.1%",
                "f": null,
                "include": true
              }
            ]
          },
          {
            "c": [
              {
                "v": "Passives",
                "f": null,
                "include": true
              },
              {
                "v": "33.2%",
                "f": null,
                "include": true
              }
            ]
          },
          {
            "c": [
              {
                "v": "Detractors",
                "f": null,
                "include": true
              },
              {
                "v": "14.7%",
                "f": null,
                "include": true
              }
            ]
          },
          {
            "c": [
              {
                "v": "Pricing Power",
                "f": null,
                "include": true
              },
              {
                "v": "3.41%",
                "f": null,
                "include": true
              }
            ]
          }
        ],
        "cols": [
          {
            "id": "nps",
            "label": "nps",
            "type": "string",
            "className": "dt-right"
          },
          {
            "id": "",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          }
        ]
      },
      "legend": [
        {
          "elementId": "bar-0",
          "name": "Expectations <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "bar",
          "symbolColor": "#008000",
          "column": {
            "id": "customer-expectations",
            "label": "Expectations",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 1,
          "visible": true,
          "baseName": "Expectations",
          "count": 450
        },
        {
          "elementId": "",
          "name": "RoadRunner <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "blueX heavy",
          "symbolColor": "",
          "column": {
            "id": "need",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 2,
          "visible": true,
          "baseName": "RoadRunner",
          "count": 450
        },
        {
          "elementId": "thick",
          "name": "Pricing Power (Bar)",
          "symbolClass": "line thick",
          "symbolColor": "#D7E4BD",
          "column": {
            "id": "competitive-trends",
            "label": "Pricing Power (Bar)",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 3,
          "visible": true,
          "baseName": "Pricing Power (Bar)",
          "count": 0
        }
      ],
      "needsList": [
        {
          "needName": "Performance",
          "needNumber": "1"
        },
        {
          "needName": "Product Availability",
          "needNumber": "6"
        },
        {
          "needName": "Innovation",
          "needNumber": "2"
        },
        {
          "needName": "Speed of Response",
          "needNumber": "12"
        },
        {
          "needName": "Convenience",
          "needNumber": "3"
        },
        {
          "needName": "Safe To Use",
          "needNumber": "5"
        },
        {
          "needName": "Knowledge-Sharing",
          "needNumber": "9"
        },
        {
          "needName": "Brand Reputation",
          "needNumber": "7"
        },
        {
          "needName": "Workplace Culture",
          "needNumber": "8"
        },
        {
          "needName": "Pricing Practices",
          "needNumber": "4"
        },
        {
          "needName": "Sales Relationship",
          "needNumber": "10"
        },
        {
          "needName": "Ease of Doing Business",
          "needNumber": "11"
        }
      ],
      "pricingPowerSeriesNumber": 3,
      "npsChartData": [
        [
          "RoadRunner",
          14.7,
          33.2,
          52.1
        ]
      ],
      "companyColorList": [
        {
          "color": "#2F5EB3",
          "companyName": "RoadRunner"
        },
        {
          "color": "#F7CE08",
          "companyName": "Premium"
        },
        {
          "color": "#D43B2D",
          "companyName": "Discount"
        },
        {
          "color": "#2DA2D4",
          "companyName": "Challenger"
        },
        {
          "color": "#8A2DD4",
          "companyName": "Value"
        }
      ]
    }
  },
  {
    "rows": [
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Precise, Flexible",
            "f": null,
            "include": true
          },
          {
            "v": ".674",
            "f": null,
            "include": true
          },
          {
            "v": "8.594",
            "f": null,
            "include": true
          },
          {
            "v": "7.919",
            "f": null,
            "include": true
          },
          {
            "v": "3.69",
            "f": null,
            "include": true
          },
          {
            "v": "5.51",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Like-Minded, Tough-Minded",
            "f": null,
            "include": true
          },
          {
            "v": "1.022",
            "f": null,
            "include": true
          },
          {
            "v": "7.997",
            "f": null,
            "include": true
          },
          {
            "v": "6.975",
            "f": null,
            "include": true
          },
          {
            "v": "3.59",
            "f": null,
            "include": true
          },
          {
            "v": "3.52",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Imaginative, Practical",
            "f": null,
            "include": true
          },
          {
            "v": ".118",
            "f": null,
            "include": true
          },
          {
            "v": "7.217",
            "f": null,
            "include": true
          },
          {
            "v": "7.099",
            "f": null,
            "include": true
          },
          {
            "v": "3.46",
            "f": null,
            "include": true
          },
          {
            "v": "28.83",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Connected, Detached",
            "f": null,
            "include": true
          },
          {
            "v": ".725",
            "f": null,
            "include": true
          },
          {
            "v": "7.163",
            "f": null,
            "include": true
          },
          {
            "v": "6.438",
            "f": null,
            "include": true
          },
          {
            "v": "3.56",
            "f": null,
            "include": true
          },
          {
            "v": "4.94",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "0",
            "f": null,
            "include": true
          },
          {
            "v": "Stable, Anxious",
            "f": null,
            "include": true
          },
          {
            "v": ".673",
            "f": null,
            "include": true
          },
          {
            "v": "5.718",
            "f": null,
            "include": true
          },
          {
            "v": "5.045",
            "f": null,
            "include": true
          },
          {
            "v": "3.50",
            "f": null,
            "include": true
          },
          {
            "v": "5.22",
            "f": null,
            "include": true
          }
        ]
      },
      {
        "c": [
          {
            "v": "1",
            "f": null,
            "include": true
          },
          {
            "v": "Average",
            "f": null,
            "include": true
          },
          {
            "v": ".643",
            "f": null,
            "include": true
          },
          {
            "v": "7.338",
            "f": null,
            "include": true
          },
          {
            "v": "6.695",
            "f": null,
            "include": true
          },
          {
            "v": "3.56",
            "f": null,
            "include": true
          },
          {
            "v": "9.604",
            "f": null,
            "include": true
          }
        ]
      }
    ],
    "cols": [
      {
        "id": "sort",
        "label": "",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "Need",
        "type": "string",
        "className": "dt-right"
      },
      {
        "id": "gap",
        "label": "Gap",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "customer-expectations",
        "label": "Ideal",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "need",
        "label": "RoadRunner",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power",
        "label": "Pricing Power",
        "type": "number",
        "className": "dt-right"
      },
      {
        "id": "pricing-power-gap",
        "label": "Power Ratio Gap",
        "type": "string",
        "className": "dt-right"
      }
    ],
    "companyList": {},
    "criteriaList": [
      {
        "name": "Show Pricing Power",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Yes"
      },
      {
        "name": "Chart Type",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "Needs"
      },
      {
        "name": "Time Period",
        "parameterName": null,
        "options": null,
        "values": null,
        "displayValue": "21-Q4 (12/31/2020 - 12/31/2021)"
      }
    ],
    "options": {
      "colors": [
        "#D7E4BD",
        "#008000",
        "#2F5EB3"
      ]
    },
    "containerId": "emotional_needs_chart",
    "otherData": {
      "breakPointList": [
        2,
        5,
        8
      ],
      "pricingPowerSeries": {
        "targetAxisIndex": 1,
        "type": "bars"
      },
      "barList": [
        {
          "className": "bar bar-0",
          "backgroundColor": "#008000",
          "index": 2,
          "seriesIndex": 3
        }
      ],
      "legend": [
        {
          "elementId": "bar-0",
          "name": "Expectations <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "bar",
          "symbolColor": "#008000",
          "column": {
            "id": "customer-expectations",
            "label": "Ideal",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 1,
          "visible": true,
          "baseName": "Expectations",
          "count": 450
        },
        {
          "elementId": "",
          "name": "RoadRunner <span class='number-of-records'>  (n=450) </span>",
          "symbolClass": "blueX heavy",
          "symbolColor": "",
          "column": {
            "id": "need",
            "label": "RoadRunner",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 2,
          "visible": true,
          "baseName": "RoadRunner",
          "count": 450
        },
        {
          "elementId": "thick",
          "name": "Pricing Power (Bar)",
          "symbolClass": "line thick",
          "symbolColor": "#D7E4BD",
          "column": {
            "id": "competitive-trends",
            "label": "Pricing Power (Bar)",
            "type": "number",
            "className": "dt-right"
          },
          "seriesNumber": 3,
          "visible": true,
          "baseName": "Pricing Power (Bar)",
          "count": 0
        }
      ],
      "needsList": [
        {
          "needName": "Precise, Flexible",
          "needNumber": "2"
        },
        {
          "needName": "Like-Minded, Tough-Minded",
          "needNumber": "1"
        },
        {
          "needName": "Imaginative, Practical",
          "needNumber": "4"
        },
        {
          "needName": "Connected, Detached",
          "needNumber": "3"
        },
        {
          "needName": "Stable, Anxious",
          "needNumber": "5"
        }
      ],
      "pricingPowerSeriesNumber": 3,
      "needsMapList": [
        {
          "name": "Product",
          "number": "1",
          "performanceAssessment": [
            {
              "name": "Performance",
              "gap": "1.006",
              "pricingPower": 3.44,
              "pricingPowerRankGroup": 2,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Innovation",
              "gap": ".787",
              "pricingPower": 3.57,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Safe To Use",
              "gap": ".861",
              "pricingPower": 3.38,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Pricing Practices",
              "gap": "1.041",
              "pricingPower": 3.58,
              "pricingPowerRankGroup": 1,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 1.006,
              "importance": 9.178,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.787,
              "importance": 9.033,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.861,
              "importance": 8.897,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 1.041,
              "importance": 8.646,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "averageExperienceComponent": {
            "emotionalName": "",
            "intensityGap": 0,
            "dissonanceGap": 0.92375,
            "importance": 8.938500000000001,
            "intensityGapRank": 2,
            "dissonanceGapRank": 2,
            "importanceRank": 1
          },
          "averagePerformanceAssessment": {
            "name": "",
            "gap": "0.92375",
            "pricingPower": 3.4925,
            "pricingPowerRankGroup": 2,
            "gapGroup": 1,
            "gapRank": 2
          }
        },
        {
          "name": "Operations",
          "number": "2",
          "performanceAssessment": [
            {
              "name": "Product Availability",
              "gap": "1.092",
              "pricingPower": 3.3,
              "pricingPowerRankGroup": 3,
              "gapGroup": 3,
              "gapRank": 0
            },
            {
              "name": "Speed of Response",
              "gap": ".945",
              "pricingPower": 3.44,
              "pricingPowerRankGroup": 2,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Workplace Culture",
              "gap": ".765",
              "pricingPower": 3.41,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Ease of Doing Business",
              "gap": ".867",
              "pricingPower": 3.59,
              "pricingPowerRankGroup": 1,
              "gapGroup": 2,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 1.092,
              "importance": 9.111,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.945,
              "importance": 8.951,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.765,
              "importance": 8.678,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.867,
              "importance": 8.612,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "averageExperienceComponent": {
            "emotionalName": "",
            "intensityGap": 0,
            "dissonanceGap": 0.91725,
            "importance": 8.838000000000001,
            "intensityGapRank": 2,
            "dissonanceGapRank": 3,
            "importanceRank": 2
          },
          "averagePerformanceAssessment": {
            "name": "",
            "gap": "0.91725",
            "pricingPower": 3.435,
            "pricingPowerRankGroup": 3,
            "gapGroup": 1,
            "gapRank": 3
          }
        },
        {
          "name": "Customer",
          "number": "3",
          "performanceAssessment": [
            {
              "name": "Convenience",
              "gap": "1.033",
              "pricingPower": 3.41,
              "pricingPowerRankGroup": 2,
              "gapGroup": 3,
              "gapRank": 0
            },
            {
              "name": "Knowledge-Sharing",
              "gap": ".91",
              "pricingPower": 3.35,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Brand Reputation",
              "gap": ".803",
              "pricingPower": 3.33,
              "pricingPowerRankGroup": 3,
              "gapGroup": 2,
              "gapRank": 0
            },
            {
              "name": "Sales Relationship",
              "gap": "1.036",
              "pricingPower": 3.49,
              "pricingPowerRankGroup": 2,
              "gapGroup": 3,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 1.033,
              "importance": 8.906,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.91,
              "importance": 8.811,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 0.803,
              "importance": 8.759,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "",
              "intensityGap": 0,
              "dissonanceGap": 1.036,
              "importance": 8.642,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "averageExperienceComponent": {
            "emotionalName": "",
            "intensityGap": 0,
            "dissonanceGap": 0.9455,
            "importance": 8.7795,
            "intensityGapRank": 2,
            "dissonanceGapRank": 1,
            "importanceRank": 3
          },
          "averagePerformanceAssessment": {
            "name": "",
            "gap": "0.9455",
            "pricingPower": 3.395,
            "pricingPowerRankGroup": 4,
            "gapGroup": 1,
            "gapRank": 1
          }
        },
        {
          "name": "Industry",
          "number": "4",
          "performanceAssessment": [
            {
              "name": "--",
              "gap": "--",
              "pricingPower": 0,
              "pricingPowerRankGroup": 4,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "--",
              "gap": "--",
              "pricingPower": 0,
              "pricingPowerRankGroup": 4,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "--",
              "gap": "--",
              "pricingPower": 0,
              "pricingPowerRankGroup": 4,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "--",
              "gap": "--",
              "pricingPower": 0,
              "pricingPowerRankGroup": 4,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "--",
              "gap": "--",
              "pricingPower": 0,
              "pricingPowerRankGroup": 4,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [],
          "averageExperienceComponent": {
            "emotionalName": "",
            "intensityGap": "NaN",
            "dissonanceGap": "NaN",
            "importance": "NaN",
            "intensityGapRank": 0,
            "dissonanceGapRank": 0,
            "importanceRank": 0
          },
          "averagePerformanceAssessment": {
            "name": "",
            "gap": "--",
            "pricingPower": 0,
            "pricingPowerRankGroup": 0,
            "gapGroup": 1,
            "gapRank": 0
          }
        },
        {
          "name": "Experience",
          "number": "5",
          "performanceAssessment": [
            {
              "name": "Precise",
              "gap": ".674",
              "pricingPower": 3.69,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Like-Minded",
              "gap": "1.022",
              "pricingPower": 3.59,
              "pricingPowerRankGroup": 1,
              "gapGroup": 3,
              "gapRank": 0
            },
            {
              "name": "Imaginative",
              "gap": ".118",
              "pricingPower": 3.46,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Connected",
              "gap": ".725",
              "pricingPower": 3.56,
              "pricingPowerRankGroup": 1,
              "gapGroup": 1,
              "gapRank": 0
            },
            {
              "name": "Stable",
              "gap": ".673",
              "pricingPower": 3.5,
              "pricingPowerRankGroup": 2,
              "gapGroup": 1,
              "gapRank": 0
            }
          ],
          "experienceComponents": [
            {
              "emotionalName": "Precise",
              "intensityGap": 3.0939999999999994,
              "dissonanceGap": 0.674,
              "importance": 0,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "Like-Minded",
              "intensityGap": 2.497,
              "dissonanceGap": 1.022,
              "importance": 0,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "Imaginative",
              "intensityGap": 1.7169999999999996,
              "dissonanceGap": 0.118,
              "importance": 0,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "Connected",
              "intensityGap": 1.6630000000000003,
              "dissonanceGap": 0.725,
              "importance": 0,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            },
            {
              "emotionalName": "Stable",
              "intensityGap": 0.21799999999999997,
              "dissonanceGap": 0.673,
              "importance": 0,
              "intensityGapRank": 0,
              "dissonanceGapRank": 0,
              "importanceRank": 0
            }
          ],
          "averageExperienceComponent": {
            "emotionalName": "",
            "intensityGap": 1.8378,
            "dissonanceGap": 0.6424,
            "importance": 0,
            "intensityGapRank": 1,
            "dissonanceGapRank": 4,
            "importanceRank": 4
          },
          "averagePerformanceAssessment": {
            "name": "",
            "gap": "0.6424",
            "pricingPower": 3.5599999999999996,
            "pricingPowerRankGroup": 1,
            "gapGroup": 1,
            "gapRank": 0
          }
        }
      ],
      "companyColorList": [
        {
          "color": "#2F5EB3",
          "companyName": "RoadRunner"
        },
        {
          "color": "#F7CE08",
          "companyName": "Premium"
        },
        {
          "color": "#D43B2D",
          "companyName": "Discount"
        },
        {
          "color": "#2DA2D4",
          "companyName": "Challenger"
        },
        {
          "color": "#8A2DD4",
          "companyName": "Value"
        }
      ]
    }
  }
      ],
      finalTrendsData:{
      },
      finalPredictiveAnalyticsData:{
      },
      finalRanksData:{
      },
      finalNeedsData:{
      },
      needsData:{
        "emotional": [
          ["Precise (vs.  Flexible)",	8.12,	7.7,	5.43],
          ["Like-Minded (vs. Tough-Minded)",	7,	6.07,	4.48],
          ["Connected (vs. Detached)",	6.77,	6.17,	5.32],
          ["Imaginative (vs. Practical)",	5.38,	5.44,	5.27],
          ["Stable (vs. Anxious)",	4.28,	3.98,	4.47]
        ],
        "functional": [
            [
              "Performance",
              9.21,
              8.1,3.41
            ],
            [
              "Convenience",
              9.04,	7.93,3.5

            ],
            [
              "Product Availability",
              9.03,	8.07,3.32

            ],
            [
              "Speed of Response",
              9.02,	7.92,3.47

            ],
            [
              "Safe To Use",
              8.98,	8.05,3.28

            ],
            [
              "Knowledge-Sharing",
              8.98,	7.89,3.41

            ],
            [
              "Innovation",
              8.97,	7.97,3.34

            ],
            [
              "Pricing Practices",
              8.85,	7.86,3.34

            ],
            [
              "Workplace Culture",
              8.84,	7.92,3.41

            ],
            [
              "Sales Relationship",
              8.82,	7.86, 3.41

            ],
            [
              "Brand Reputation",
              8.78,	8.1, 3.47

            ],
            [
              "Ease of Doing Business",
              8.76,	7.84, 3.57

            ]
         ],
         "legend": {
          "normal" : ['Expectations','RoadRunner','Pricing Power (Bar)'],
          "respondents" : ['Expectations (n=344)','RoadRunner (n=344)','Pricing Power (Bar)'],
         },
         "colors": ["#008000","#2F5EB3","#D7E4BD"],
         "pricingPowerSeriesNumber": 3
      },
    };
  },
  methods: {
    showModal: function() {
      this.$modal.show('user-agreement-modal');
    },
    parseForPredictiveAnalytics:function(){
      let itemsToRemove = {
          lastColumns: 0,
          firstRows: 1,
          firstColumns: 0
        };
      let data = {};
      let chart1Data = this.inputForPredictive;
      data = PredictiveAnalyticsService.parseData(1,chart1Data,data,itemsToRemove,false);
      data = PredictiveAnalyticsService.parseLegendAndColorData(chart1Data,data);
      this.finalPredictiveAnalyticsData = JSON.parse(JSON.stringify(data));
    },
    parseForRanks:function(){
      let itemsToRemove = {
          lastColumns: 0,
          firstRows: 1,
          firstColumns: 0
        };
      let data = {};
      let chart1Data = this.inputForMoatRanks[1];
      data = RanksService.parseData(1,chart1Data,data,itemsToRemove,false);
      data = RanksService.parseLegendAndColorData(chart1Data,data);
      this.finalRanksData = JSON.parse(JSON.stringify(data));
    },
    parseForTrends:function(){
      let itemsToRemove = {
          lastColumns: 0,
          firstColumns: 0
        };
      let data = {};
      let chart1Data = this.inputDataForTrends[0];
      data = TrendsService.parseData(1,chart1Data,data,itemsToRemove,false);
      data = TrendsService.parseLegendAndColorData(chart1Data,data);
      data = TrendsService.parseAxisData(chart1Data,data);
      this.finalTrendsData = JSON.parse(JSON.stringify(data));
    },
    parseMatchProfileDataForValueDriver:function(){
      let itemsToRemove = {
//          lastColumns: 2,
          firstColumns: 1
 //         gapColumn: 2,
 //         otherColumns: [1],
        };
        let data = {};
        let chart1Data = this.inputDataForMatchValue[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(this.inputDataForMatchValue[1],data);
        data = ProfileService.parseDriverListData(this.inputDataForMatchValue[0],data);
        this.finalNeedsData = JSON.parse(JSON.stringify(data));
        this.displayPricingPower = false;
        this.drawChart = true;
        this.eChartCriteria.eChartType = "bar-horizontal";
    },
    parseProfileDataForValueDriver: function(){
      let itemsToRemove = {
          lastColumns: 2,
          firstColumns: 1,
          gapColumn: 2,
          otherColumns: [1],
        };
        let data = {};
        let chart1Data = this.inputDataForValue[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(this.inputDataForValue[1],data);
        data = ProfileService.parseDriverListData(this.inputDataForValue[0],data);
        this.finalNeedsData = JSON.parse(JSON.stringify(data));
        this.displayPricingPower = false;
        this.drawChart = true;
        this.eChartCriteria.eChartType = "bar-horizontal";
    },
    parseProfileDataForValue: function(){
      let itemsToRemove = {
          lastColumns: 2,
          firstColumns: 2,
          gapColumn: 1,
        };
        let data = {};
        let chart1Data = this.inputDataForValue[0];
        let chart2Data = this.inputDataForValue[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
//        data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(this.inputDataForValue[0],data);
        this.finalNeedsData = JSON.parse(JSON.stringify(data));
        this.drawChart = true;
    },
    parseMatchProfileDataForMoat: function(){
      let itemsToRemove = {
        firstColumns: 1        
      };
      let data = {};
      let chart1Data = this.inputDataForMatchMoat[0];
      let chart2Data = this.inputDataForMatchMoat[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(this.inputDataForMatchMoat[0],data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;
    },
    parseProfileDataForMoat: function(){
      
      let itemsToRemove = {
        lastColumns: 2,
        firstColumns: 1,
        gapColumn: 1,
      };
      let data = {};
      let chart1Data = this.inputDataForMoat[0];
      let chart2Data = this.inputDataForMoat[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(this.inputDataForMoat[0],data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;
    },
    parseProfileDataForWinner: function(){
      
      let itemsToRemove = {
        lastColumns: 2,
        firstColumns: 1,
        gapColumn: 1
      };

      let data = {};
      let chart1Data = this.inputDataForWinner[0];
      let chart2Data = this.inputDataForWinner[1];
      let chart3Data = this.inputDataForWinner[2];
      let mergedRows = [...chart1Data.rows, ...chart2Data.rows, ...chart3Data.rows];
      chart1Data.rows = mergedRows;
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(this.inputDataForWinner[0],data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;
    },    
    parseMatchProfileDataForWinner: function(){
      
      let itemsToRemove = {
        firstColumns: 1,
      };

      let data = {};
      let chart1Data = this.inputDataForMatchWinner[0];
      let chart2Data = this.inputDataForMatchWinner[1];
      let chart3Data = this.inputDataForMatchWinner[2];
      let mergedRows = [...chart1Data.rows, ...chart2Data.rows, ...chart3Data.rows];
      chart1Data.rows = mergedRows;
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(this.inputDataForMatchWinner[0],data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;

    },
    parseProfileDataForNeed: function(){
      
      let itemsToRemove = {
        lastColumns: 2,
        firstColumns: 1,
        gapColumn: 1,
        lastRows: 1
      };

      let data = {};
      let chart1Data = this.inputDataForNeed[0];
      let chart2Data = this.inputDataForNeed[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(this.inputDataForNeed[0],data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;
    },    
    parseMatchProfileDataForValue: function(){
      let itemsToRemove = {
          firstColumns: 2,
      };
/*      
      itemsToRemoveEmotionalNeed: {
        
      }        
*/        
        let data = {};
        let chart1Data = this.inputDataForMatchValue[0];
        let chart2Data = this.inputDataForMatchValue[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
//        data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(this.inputDataForMatchValue[0],data);
        this.finalNeedsData = JSON.parse(JSON.stringify(data));
        this.drawChart = true;
    },
    parseMatchProfileDataForNeed: function(){
      
      let itemsToRemove = {
       // lastColumns: 2,
        firstColumns: 1,
        //gapColumn: 1,
        lastRows: 1
      };

      let data = {};
      let chart1Data = this.inputDataForMatchNeed[0];
      let chart2Data = this.inputDataForMatchNeed[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(chart1Data,data);
      this.finalNeedsData = JSON.parse(JSON.stringify(data));
      this.drawChart = true;
    },    

    setDisplayNumberOfResponses(inputDisplayNumberOfResponses){
      this.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.eChartType = inputEChartType;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    setChartType(inputEChartType, inputRecalculate){
      this.eChartCriteria.eChartType = inputEChartType;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.eChartType = inputEChartType;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    setAngleText(inputAngleText){
      this.eChartCriteria.angleText = inputAngleText;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.angleText = inputAngleText;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    setShowGoalLine(inputShowGoalLine){
      this.eChartCriteria.showGoalLine = inputShowGoalLine;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.showGoalLine = inputShowGoalLine;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    setShowLegend(inputShowLegend){
      this.eChartCriteria.showLegend = inputShowLegend;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.showLegend = inputShowLegend;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    setShowLabels(inputShowLabels){
      this.eChartCriteria.showLabels = inputShowLabels;
//      this.$parent.$parent.$refs.chartCriteria.eChartCriteria.showLabels = inputShowLabels;
      this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
    },
    saveNpsReportTable() {},
    buildClientChart: function(){},    
    rebuildClientChart: function(){
      //this.$refs.profileChart.processChart(this.hasChartRun);
    },
    setEChartCriteria: function(){
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "eChartType")) {
		    this.eChartCriteria.eChartType = "stacked-bar-vertical";
	    }
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "displayNumberOfResponses")) {
        this.eChartCriteria.displayNumberOfResponses = false;  
      }	        
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "angleText")) {
        this.eChartCriteria.angleText = true;  
      }	        
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showGoalLine")) {
        this.eChartCriteria.showGoalLine = true;
      }	        
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showLegend")) {
		    this.eChartCriteria.showLegend = true;
	    }
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showLabels")) {
        this.eChartCriteria.showLabels = true;  
      }	        
      if (!Object.prototype.hasOwnProperty.call(this.eChartCriteria, "colorPaletteId")) {
        this.eChartCriteria.colorPaletteId = 0;
      }	        
      this.buildClientChart();
    },     
  },
  created() {},
  mounted() {
    if (UserService.getDisplayAgreement() == "Y"){
      this.showModal();
    }
    if (this.displayType === "winner"){
      this.parseProfileDataForWinner();
    } else if (this.displayType === "need"){
      this.parseProfileDataForNeed();
    } else if (this.displayType === "moat"){
      this.parseProfileDataForMoat();
    } else if (this.displayType === "value"){
      this.parseProfileDataForValue();
    } else if (this.displayType === "value-driver"){
      this.parseProfileDataForValueDriver();
    } else if (this.displayType === "match-need"){
      this.parseMatchProfileDataForNeed();
    } else if (this.displayType === "match-value"){
      this.parseMatchProfileDataForValue();
    } else if (this.displayType === "match-value-driver"){
      this.parseMatchProfileDataForValueDriver();
    } else if (this.displayType === "match-moat"){
      this.parseMatchProfileDataForMoat();
    } else if (this.displayType === "match-winner"){
      this.parseMatchProfileDataForWinner();
    }
    if (this.isTrends){
      this.parseForTrends();
    }
    this.parseForRanks();
    this.parseForPredictiveAnalytics();
    this.setEChartCriteria();
//    this.$refs.profileChart.processChart(this.drawChart,this.displayType,this.finalNeedsData,this.eChartCriteria,this.displayPricingPower);
//    this.$refs.trendsChart.processChart(this.drawChart,this.displayTypeForTrends,this.finalTrendsData,this.eChartCriteria,true);
//    this.$refs.ranksChart.processChart(this.drawChart,this.displayTypeForRanks,this.finalRanksData,this.eChartCriteria);
    this.eChartCriteria.eChartType = "line";
    this.$refs.predictiveAnalyticsChart.processChart(this.drawChart,this.displayTypeForPredictiveAnalytics,this.finalPredictiveAnalyticsData,this.eChartCriteria);
  }
};
</script>
<style lang="scss">
</style>
